import _ from 'underscore';
import { GetJsDataInfo } from '@bingads-webui-clientcenter/js-data-cc-rest-base';
import type {
  CCJsDataRepositories,
  EntityId,
} from './types';

const ccJsDataObj: Record<EntityId, CCJsDataRepositories> = {};

export function getCCJsDataObj(
  cid: EntityId,
  uid: EntityId,
  ccBaseUrl?: string
) {
  if (ccJsDataObj[cid]) {
    return ccJsDataObj[cid];
  }

  const { jsDataCcRest } = GetJsDataInfo({
    cidFetcher: _.constant(cid),
    uidFetcher: _.constant(uid),
  }, ccBaseUrl);
  const repositories = jsDataCcRest as CCJsDataRepositories;
  ccJsDataObj[cid] = repositories;
  return repositories;
}
